<template>
  <div>
    <h1 class="header">Über uns</h1>
    <a href="https://www.instagram.com/heimreise_film/" target="_blank">Instagram</a>
    <div class="flex flex-col mt-8">
      <div class="card">
        <img src="@/assets/Frank.jpg" alt="Profilbild Frank Stoll" class="image hidden md:block" />
        <div class="content">
          <div>
            <h3 class="title">Frank</h3>
            <p class="description">
              Nachdem ich durch Australien und Neuseeland auf vier Rädern gereist bin, war auch zurück in Deutschland klar, dass ein Zuhause auf vier Rädern her muss.
              Ein paar Monate später stand dann endlich ein VW T4 namens Rudi vor der Tür und eine neue Ära konnte
              beginnen.
              <br>
              Ich bin 30 Jahre alt, wohne in Freiburg und arbeite als Gestalter für visuelles
              Marketing.
              Man muss nicht immer gleich den Job kündigen und weit weit wegfahren um das
              Fernweh zu stillen. Meiner Meinung nach kann man sein Leben in jeder Lebenslage so gestalten, dass es zu einer spannenden und abenteuerlichen Reise wird.
            </p>
          </div>
          <div class="tags">
            <a href="https://www.instagram.com/pinepins/" target="_blank" class="tag">
              <instagram-icon class="h-4" />pinepins
            </a>
            <a
              href="https://www.youtube.com/channel/UCjj_LW173qX3YwwQKMCSXPQ"
              class="tag"
              target="_blank"
            >
              <youtube-icon class="h-4" />pinepins
            </a>
          </div>
        </div>
      </div>
      <div class="card">
        <img
          src="@/assets/Mathis.jpg"
          alt="Profilbild Mathis Ochsenmeier"
          class="image hidden md:block"
        />
        <div class="content">
          <div>
            <h3 class="title">Mathis</h3>
            <p class="description">
              Seit der zehnten Klasse habe ich schon von einem Bus geträumt, in dem ich nach dem Abitur die Freiheit genießen und durch Europa reisen kann.
              Nach der Arbeit am Fließband ging dann das Abenteuer los, alles mit der Kamera zu begleiten war ebenfalls eines meiner großen Ziele. Und plötzlich haben sich ziemlich viele Menschen für diese Videos interessiert.
              <br>
              Ich wohne in Kiel und bin seit knapp zwei Jahren freiberuflicher Videoproduzent.
              Um auf die Idee zu kommen, mit meinem Bus die eigene Heimat zu erkunden, habe ich drei Jahre gebraucht. Man sollte auch im eigenen Land mit offenen Augen durch die Gegend gehen, und nicht erst in der weiten Ferne. Es gibt mehr zu entdecken, als man denkt.
            </p>
          </div>
          <div class="tags">
            <a href="https://www.instagram.com/mathis_ox/" target="_blank" class="tag">
              <instagram-icon class="h-4" />mathis_ox
            </a>
            <a href="https://www.youtube.com/mathis_ox" class="tag" target="_blank">
              <youtube-icon class="h-4" />mathis_ox
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { InstagramIcon, YoutubeIcon } from 'vue-feather-icons'
export default {
  components: { InstagramIcon, YoutubeIcon }
}
</script>
